import http from "../http-common";
/* eslint-disable */
class PelatihanEvaluasiFasilitatorService {
  evaluasiList(page, itemPerPage, keyword, kegiatanId) {
    return http.get(
      "/pelatihan/evaluasi-aspek-fasilitator/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&kegiatan_id=" +
        kegiatanId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    return http.post("/pelatihan/evaluasi-aspek-fasilitator", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  update(data) {
    return http.put(`/pelatihan/evaluasi-aspek-fasilitator/${data.id}`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  delete(id) {
    return http.delete(`/pelatihan/evaluasi-aspek-fasilitator/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new PelatihanEvaluasiFasilitatorService();
